import React, { memo } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../../common';
import { toggleBreakingNewsAction } from '../../../common/actions/breakingNewsAction';
import { smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { CloseIcon } from '../../common/utilities/closeIcon';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';

interface BreakingNewsCloseIconProps {
    isMobile: boolean;
    toggleBreakingNewsAction(toggleVisibility: boolean): void;
}

const mapStoreStateToProps = (storeState: any) => {};

const mapDispatchToProps = {
    toggleBreakingNewsAction
};

export const BreakingNewsCloseIcon = withScreenSize(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({
    isMobile,
    toggleBreakingNewsAction
}: BreakingNewsCloseIconProps) => {
    return (
        <Container onClick={() => toggleBreakingNewsAction(false)}>
            <CloseIconWrapper>
                <CloseIcon 
                    width={isMobile ? 10 : 14}
                    height={isMobile ? 10 : 14}  />
            </CloseIconWrapper>
        </Container>
    );
})));

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    z-index: 2;
`;

const CloseIconWrapper = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0px;
    -webkit-transform: translate(-2%, -25%);
    transform: translate(-2%, -25%);
    border-radius: 50%;
    border: 2px solid #FFF;
    cursor: pointer;
    margin-top: 10px;
    width: 34px;
    height: 34px;
    @media ${smallMediaQuery} {
        width: 25px;
        height: 25px;
        margin-top: 6px;
    }
`;